"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Helpers = exports.normalizeRelators = exports.recurseRelators = void 0;
var relator_1 = __importDefault(require("../classes/relator"));
function recurseRelators(data, relators, depth, keys, relatorDataCache) {
    return __awaiter(this, void 0, void 0, function () {
        var included, curRelatorDataCache, _a, _b, _i, name_1, cache, data_1, data_1_1, datum, relatedData, e_1_1, newRelatorDataCache, curRelatorDataCache_1, curRelatorDataCache_1_1, _c, relator, cache, i, resource, key, e_2_1;
        var e_1, _d, e_2, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    included = [];
                    curRelatorDataCache = relatorDataCache || new Map();
                    if (!(!relatorDataCache && depth > 0)) return [3 /*break*/, 10];
                    _a = [];
                    for (_b in relators)
                        _a.push(_b);
                    _i = 0;
                    _f.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 10];
                    name_1 = _a[_i];
                    cache = curRelatorDataCache.get(relators[name_1]) || [];
                    curRelatorDataCache.set(relators[name_1], cache);
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 7, 8, 9]);
                    data_1 = (e_1 = void 0, __values(data)), data_1_1 = data_1.next();
                    _f.label = 3;
                case 3:
                    if (!!data_1_1.done) return [3 /*break*/, 6];
                    datum = data_1_1.value;
                    return [4 /*yield*/, relators[name_1].getRelatedData(datum)];
                case 4:
                    relatedData = _f.sent();
                    if (relatedData !== null) {
                        cache.push.apply(cache, __spreadArray([], __read((Array.isArray(relatedData) ? relatedData : [relatedData]))));
                    }
                    _f.label = 5;
                case 5:
                    data_1_1 = data_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _f.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (data_1_1 && !data_1_1.done && (_d = data_1["return"])) _d.call(data_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    _i++;
                    return [3 /*break*/, 1];
                case 10:
                    if (!(depth-- > 0 && curRelatorDataCache.size > 0)) return [3 /*break*/, 21];
                    newRelatorDataCache = new Map();
                    _f.label = 11;
                case 11:
                    _f.trys.push([11, 18, 19, 20]);
                    curRelatorDataCache_1 = (e_2 = void 0, __values(curRelatorDataCache)), curRelatorDataCache_1_1 = curRelatorDataCache_1.next();
                    _f.label = 12;
                case 12:
                    if (!!curRelatorDataCache_1_1.done) return [3 /*break*/, 17];
                    _c = __read(curRelatorDataCache_1_1.value, 2), relator = _c[0], cache = _c[1];
                    i = 0;
                    _f.label = 13;
                case 13:
                    if (!(i < cache.length)) return [3 /*break*/, 16];
                    return [4 /*yield*/, relator.getRelatedResource(cache[i], undefined, undefined, newRelatorDataCache)];
                case 14:
                    resource = _f.sent();
                    key = resource.getKey();
                    if (!keys.includes(key)) {
                        keys.push(key);
                        included.push(resource);
                    }
                    _f.label = 15;
                case 15:
                    i++;
                    return [3 /*break*/, 13];
                case 16:
                    curRelatorDataCache_1_1 = curRelatorDataCache_1.next();
                    return [3 /*break*/, 12];
                case 17: return [3 /*break*/, 20];
                case 18:
                    e_2_1 = _f.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 20];
                case 19:
                    try {
                        if (curRelatorDataCache_1_1 && !curRelatorDataCache_1_1.done && (_e = curRelatorDataCache_1["return"])) _e.call(curRelatorDataCache_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 20:
                    curRelatorDataCache = newRelatorDataCache;
                    return [3 /*break*/, 10];
                case 21: return [2 /*return*/, included];
            }
        });
    });
}
exports.recurseRelators = recurseRelators;
function normalizeRelators(relators) {
    var e_3, _a;
    var normalizedRelators = {};
    if (relators) {
        if (relators instanceof relator_1["default"]) {
            normalizedRelators[relators.relatedName] = relators;
            return normalizedRelators;
        }
        else if (relators instanceof Array) {
            try {
                for (var relators_1 = __values(relators), relators_1_1 = relators_1.next(); !relators_1_1.done; relators_1_1 = relators_1.next()) {
                    var relator = relators_1_1.value;
                    normalizedRelators[relator.relatedName] = relator;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (relators_1_1 && !relators_1_1.done && (_a = relators_1["return"])) _a.call(relators_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return normalizedRelators;
        }
        else {
            return relators;
        }
    }
    return undefined;
}
exports.normalizeRelators = normalizeRelators;
var Helpers = /** @class */ (function () {
    function Helpers(options) {
        // Relators
        this.relators = normalizeRelators(options.relators);
        // Projection
        if (options.projection === undefined) {
            this.projectAttributes = function () { return undefined; };
        }
        else if (options.projection === null) {
            this.projectAttributes = function (data) {
                var attributes = Object.assign({}, data);
                delete attributes[options.idKey];
                return attributes;
            };
        }
        else {
            var projection_1 = options.projection;
            var type = Object.values(projection_1)[0];
            if (type === 0) {
                this.projectAttributes = function (data) {
                    var keys = Object.keys(data);
                    var attributes = {};
                    for (var i = 0, len = keys.length; i < len; i++) {
                        if (!(keys[i] in projection_1)) {
                            attributes[keys[i]] = data[keys[i]];
                        }
                    }
                    delete attributes[options.idKey];
                    return attributes;
                };
            }
            else {
                var keys_1 = Object.keys(projection_1);
                this.projectAttributes = function (data) {
                    var attributes = {};
                    for (var i = 0, len = keys_1.length; i < len; i++) {
                        attributes[keys_1[i]] = data[keys_1[i]];
                    }
                    delete attributes[options.idKey];
                    return attributes;
                };
            }
        }
    }
    return Helpers;
}());
exports.Helpers = Helpers;
//# sourceMappingURL=serializer.utils.js.map